$(document).ready(function () {
    // Seleciona todos os elementos com o atributo data-distance-labels
    $('[data-distance-labels]').each(function () {
        var $parentElement = $(this); // Seleciona o elemento pai atual
        var $spans = $parentElement.find('span'); // Seleciona os spans dentro do elemento pai

        // Ordena os spans com base no valor do atributo data-label
        $spans.sort(function (a, b) {
            return parseFloat($(b).attr('data-label')) - parseFloat($(a).attr('data-label'));
        });

        // Remove todos os spans do elemento pai atual
        $parentElement.empty();

        // Adiciona os spans ordenados de volta ao elemento pai atual
        $spans.appendTo($parentElement);
    });
  
    // Seleciona todos os elementos com a classe 'download-link'
    const downloadLinks = document.querySelectorAll('.download-link');
  
    downloadLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault(); // Impede o comportamento padrão de abrir o link
        console.log("rti")
        const fileUrl = link.getAttribute('data-url'); // Obtém o URL dinâmico
        const fileName = link.getAttribute('data-filename'); // Obtém o nome do arquivo dinâmico
  
        // Faz uma requisição para o arquivo e força o download
        fetch(fileUrl)
          .then(response => response.blob())
          .then(blob => {
            const a = document.createElement('a');
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName; // Nome dinâmico
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url); // Libera o objeto blob
            document.body.removeChild(a);
          })
          .catch(() => alert('Erro ao baixar o arquivo'));
      });
    });
});

